// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-title {\n  background-color: #EFEEED;\n}\n.msg-block {\n  background-color: #D3D3D3;\n}\n.uppy-height {\n  height: 350px;\n}\n.uppy-Dashboard-innerWrap {\n  height: 350px;\n}\n.uppy-Dashboard-files .uppy-Dashboard-Item {\n  width: 15%;\n}\n.upArrow:before {\n  opacity: 1!important;\n}\n.downArrow:after {\n  opacity: 1!important;\n}\n", ""]);
// Exports
module.exports = exports;
